import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { SettingsWrapperControl } from './settings-wrapper-control';
import { DesignControl } from './design-control';
import { TemplateControlService } from './template-control.service';
import { Subscription } from 'rxjs';

const displayControlTemplate = `
<div style="font-size: 14px; font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: 400; color: #000000">
Insert text here...
</div>`;
const settingsControlTemplate = ``;

export class TextControl extends DesignControl {
  editTextControl: HTMLElement;
  settingsControl: SettingsWrapperControl;
  saveEdit$: Subscription;
  cancelEdit$: Subscription;

  constructor(document: Document, templateControlService: TemplateControlService) {
    super(document, templateControlService);

    this.controlTemplate = displayControlTemplate;
    this.settingsTemplate = settingsControlTemplate;
    this.controlType = TemplateControlType.Text;
    this.settingsControl = templateControlService.settingsWrapperControl;
  }

  public edit(): void {
    const textValue = this.controlElement.innerHTML;

    this.saveEdit$ = this.templateControlService.richTextUpdates$.subscribe(value => {
      this.controlElement.innerHTML = value;
      this.settingsControl.hide();

      this.saveEdit$.unsubscribe();
      this.cancelEdit$.unsubscribe();
    });

    this.cancelEdit$ = this.templateControlService.richTextCancel$.subscribe(() => {
      this.settingsControl.hide();

      this.saveEdit$.unsubscribe();
      this.cancelEdit$.unsubscribe();
    });

    this.templateControlService.editRichText(textValue);
  }

  public cancel(): void {}

  public save(): void {}

  public copy(): void {}

  public destroy(): void {}
}
